import {PayoutPageTabs} from "../../../components/payouts/v2/tabs";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";

export default function PayoutV2Page() {
  return (
    <DashboardWrapper pageTitle="Payouts">
      <StyledPageHeader>Payout</StyledPageHeader>
      <PayoutPageTabs />
    </DashboardWrapper>
  );
}
